import React, { useState } from 'react';
import StepShell from './StepShell';
import FieldStack, { ChoiceCard } from './FieldStack';
import { SelectField } from '../../../ui/select-field';
import { BULB_OPTIONS } from '../../fixtures';
import { Sun, Zap, MoonStar, Timer, X } from 'lucide-react';

const Lighting = () => {
  const [usage, setUsage] = useState('sometimes');
  const [bulb, setBulb] = useState('led');
  const [deviceMgmt, setDeviceMgmt] = useState(null);

  return (
    <StepShell
      title='Lighting'
      description='Do you use extra lighting while working from home?'>
      <FieldStack label='Do you use additional lighting while working?' required>
        <div className='space-y-2'>
          <ChoiceCard
            active={usage === 'always'}
            icon={Sun}
            label='Always'
            desc='Every WFH day'
            onClick={() => setUsage('always')}
          />
          <ChoiceCard
            active={usage === 'sometimes'}
            icon={MoonStar}
            label='Sometimes'
            desc='Only on dark days or evenings'
            onClick={() => setUsage('sometimes')}
          />
          <ChoiceCard
            active={usage === 'never'}
            icon={X}
            label='Never'
            desc='Natural light only'
            onClick={() => setUsage('never')}
          />
        </div>
      </FieldStack>

      {usage !== 'never' && (
        <>
          <FieldStack label='What type of light bulbs do you use?' required>
            <SelectField
              options={BULB_OPTIONS}
              value={bulb}
              onChange={setBulb}
              placeholder='Pick a bulb type...'
              className='mb-0'
            />
          </FieldStack>

          <FieldStack
            label='Do you use a smart plug or timer for your lights?'
            hint="Used to adjust your lighting usage in the calculation">
            <div className='grid grid-cols-2 gap-2'>
              <ChoiceCard
                active={deviceMgmt === 'yes'}
                icon={Timer}
                label='Yes'
                onClick={() => setDeviceMgmt('yes')}
              />
              <ChoiceCard
                active={deviceMgmt === 'no'}
                icon={Zap}
                label='No'
                onClick={() => setDeviceMgmt('no')}
              />
            </div>
          </FieldStack>
        </>
      )}
    </StepShell>
  );
};

export default Lighting;
